'use client'

import {
    MdMic,
    MdPause,
    MdPlayArrow,
    MdStop,
    MdFiberManualRecord,
} from 'react-icons/md'

interface RecordingControlsProps {
    isRecording: boolean
    isPaused: boolean
    onStart: () => void
    onPause: () => void
    onResume: () => void
    onStop: () => void
    disabled?: boolean
    size?: 'sm' | 'md' | 'lg'
}

export function RecordingControls({
    isRecording,
    isPaused,
    onStart,
    onPause,
    onResume,
    onStop,
    disabled = false,
    size = 'md',
}: RecordingControlsProps) {
    const buttonSizeClass = {
        sm: 'btn-sm',
        md: 'btn-md',
        lg: 'btn-lg',
    }[size]

    const iconSizeClass = {
        sm: 'text-base',
        md: 'text-xl',
        lg: 'text-2xl',
    }[size]

    if (!isRecording) {
        return (
            <button
                onClick={onStart}
                disabled={disabled}
                className={`btn btn-secondary ${buttonSizeClass} gap-2`}
            >
                <MdMic className={iconSizeClass} />
                Iniciar Gravacao
            </button>
        )
    }

    return (
        <div className="flex items-center gap-3">
            {isPaused ? (
                <button
                    onClick={onResume}
                    disabled={disabled}
                    className={`btn btn-warning ${buttonSizeClass} gap-2`}
                >
                    <MdPlayArrow className={iconSizeClass} />
                    Continuar
                </button>
            ) : (
                <button
                    onClick={onPause}
                    disabled={disabled}
                    className={`btn btn-warning ${buttonSizeClass} gap-2`}
                >
                    <MdPause className={iconSizeClass} />
                    Pausar
                </button>
            )}
            <button
                onClick={onStop}
                disabled={disabled}
                className={`btn btn-error ${buttonSizeClass} gap-2`}
            >
                <MdStop className={iconSizeClass} />
                Finalizar
            </button>
        </div>
    )
}

interface RecordingStatusProps {
    isRecording: boolean
    isPaused: boolean
}

export function RecordingStatus({ isRecording, isPaused }: RecordingStatusProps) {
    if (!isRecording) return null

    return (
        <div className="flex items-center justify-center gap-2 text-sm">
            <MdFiberManualRecord
                className={`text-error ${!isPaused ? 'animate-pulse' : ''}`}
            />
            <span className="text-base-content">
                {isPaused ? 'Gravacao pausada' : 'Gravando...'}
            </span>
        </div>
    )
}
